import { useEffect, useRef } from "react";

function YouTubeVideo({ link }) {
    const iframeRef = useRef(null);

    useEffect(() => {
        const iframe = iframeRef.current;

        if (!iframe) return;

        const sendCommand = (func, args = []) => {
            iframe.contentWindow?.postMessage(
                JSON.stringify({
                    event: "command",
                    func,
                    args,
                }),
                "*"
            );
        };

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // Play when video enters viewport
                    sendCommand("playVideo");

                    // Try to unmute
                    sendCommand("unMute");

                    // Set volume to 100
                    sendCommand("setVolume", [100]);
                } else {
                    // Pause when scrolling away
                    sendCommand("pauseVideo");
                }
            },
            {
                threshold: 0.5,
            }
        );

        observer.observe(iframe);

        return () => {
            observer.disconnect();
        };
    }, []);

    const getVideoId = (url) => {
        try {
            const parsedUrl = new URL(url);

            if (parsedUrl.hostname.includes("youtube.com")) {
                return parsedUrl.searchParams.get("v");
            }

            if (parsedUrl.hostname.includes("youtu.be")) {
                return parsedUrl.pathname.substring(1);
            }

            return null;
        } catch {
            return null;
        }
    };

    const videoId = getVideoId(link);

    if (!videoId) {
        return null;
    }

    const embedUrl =
        `https://www.youtube.com/embed/${videoId}` +
        `?enablejsapi=1` +
        `&playsinline=1` +
        `&controls=0` +
        `&rel=0` +
        `&iv_load_policy=3` +
        `&modestbranding=1` +
        `&loop=1` +
        `&playlist=${videoId}`;

    return (
        <div className="youtube-video-wrapper">
            <iframe
                ref={iframeRef}
                src={embedUrl}
                title="YouTube video"
                frameBorder="0"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
}

export default YouTubeVideo;
